export default __webpack_public_path__ + "static/media/map-pin.f6f8c483.svg";